import axiosInstance from "../../apiAxios/axiosInstance";
export const getDepartmentList = async (payload) => {
  const response = await axiosInstance.post("/vendor/department-list",payload);
  return response.data;

};
export const ActiveDepartmentList = async (payload) => {
  const response = await axiosInstance.get("/vendor/active-department-list",payload);
  return response.data;
};
export const DeleteDepartment = async (payload) => {
  const res = await axiosInstance.post("/vendor/department-delete", payload)
  return res.data
};
export const DepartmentUpdate = async (payload) => {
  const res = await axiosInstance.post("/vendor/department-update", payload)
  return res.data
};

export const createDepartment = async (data) => {
  const response = await axiosInstance.post("/vendor/department-store", data);
  return response.data;
};

export const getDepartmentById = async (id) => {
  const response = await axiosInstance.post("/vendor/department-show", { id, });
  return response.data;
}
export const ChanegDepartmentstatus = async (paylaod) => {
  const response = await axiosInstance.post("/vendor/department-status-update", paylaod)
};